import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { PROCEDURES } from '../../navigation/ROUTE_CONSTANTS';
import { createProcedure, getOneProcedure, getProcedures, removeProcedure, updateProcedure } from '../../services/proceduresService';
import { genericError } from '../actions/error.actions';
import {
    CREATE_PROCEDURE,
    DELETE_PROCEDURE,
    getAdminListProceduresSuccess,
    getProceduresSuccess,
    getSelectedProcedureSuccess,
    GET_ADMIN_LIST_PROCEDURES,
    GET_LIST_PROCEDURES,
    GET_SELECTED_PROCEDURE, UPDATE_PROCEDURE
} from '../actions/procedures.actions';
import { disableOverlay, enableOverlay, setFormSubmittedSuccess, setNavigateTo, setToast } from '../actions/ui.actions';
import { TOAST_SEVERITY_SUCCESS } from '../reducers/ui.reducer';

/**
 * getListProceduresEffect
 */
function* getListProceduresEffect() {
    try {
        const proceduresList = yield call(getProcedures);
        yield put(getProceduresSuccess(proceduresList));

    } catch (err) {
        console.log('error:', err);
        yield put(genericError(err));
    }
}

/**
 * getAdminListProceduresEffect
 */
function* getAdminListProceduresEffect() {
    yield put(enableOverlay('Loading procedures ...'));
    try {
        const proceduresList = yield call(getProcedures);
        yield put(getAdminListProceduresSuccess(proceduresList));
    } catch (err) {
        console.log('error:', err);
        yield put(genericError(err));
    }
    yield put(disableOverlay());
}

/**
 * getSelectedProcedureEffect
 */
function* getSelectedProcedureEffect({ payload }) {
    yield put(enableOverlay('Loading procedure ...'));
    try {
        const procedure = yield call(getOneProcedure, payload);
        yield put(getSelectedProcedureSuccess(procedure));
    } catch (err) {
        console.log('error:', err);
        yield put(genericError(err));
    }
    yield put(disableOverlay());
}

/**
 * createProcedureEffect
 */
function* createProcedureEffect({ payload }) {
    try {
        yield put(enableOverlay('Creating procedure ...'));
        const procedure = yield call(createProcedure, payload);
        if (procedure) {
            yield put(setToast({
                severity: TOAST_SEVERITY_SUCCESS,
                detail: 'The procedure has been created!',
            }));
            yield put(setFormSubmittedSuccess(true));
        }
    } catch (err) {
        console.log('error:', err);
        yield put(genericError(err));
    }
    yield put(disableOverlay());
}

/**
 * updateProcedureEffect
 */
function* updateProcedureEffect({ payload }) {
    try {
        yield put(enableOverlay('Updating procedure ...'));
        const procedure = yield call(updateProcedure, payload);
        if (procedure) {
            yield put(setToast({
                severity: TOAST_SEVERITY_SUCCESS,
                detail: 'The procedure has been updated!',
            }));
            yield put(setFormSubmittedSuccess(true));
        }
    } catch (err) {
        console.log('error:', err);
        yield put(genericError(err));
    }
    yield put(disableOverlay());
}

/**
 * deleteProcedureEffect
 */
function* deleteProcedureEffect({ payload }) {
    try {
        yield put(enableOverlay('Deleting procedure ...'));
        const procedure = yield call(removeProcedure, payload);
        if (procedure) {
            yield put(setToast({
                severity: TOAST_SEVERITY_SUCCESS,
                detail: 'The procedure has been deleted!',
            }));
            yield put(setNavigateTo(PROCEDURES));
        }
    } catch (err) {
        console.log('error:', err);
        yield put(genericError(err));
    }
    yield put(disableOverlay());
}

export function* watchGetListProcedures() {
    yield takeEvery(GET_LIST_PROCEDURES, getListProceduresEffect);
}

export function* watchGetAdminListProcedures() {
    yield takeEvery(GET_ADMIN_LIST_PROCEDURES, getAdminListProceduresEffect);
}

export function* watchGetSelectedProcedure() {
    yield takeEvery(GET_SELECTED_PROCEDURE, getSelectedProcedureEffect);
}

export function* watchCreateProcedure() {
    yield takeEvery(CREATE_PROCEDURE, createProcedureEffect);
}

export function* watchUpdateProcedure() {
    yield takeEvery(UPDATE_PROCEDURE, updateProcedureEffect);
}

export function* watchDeleteProcedure() {
    yield takeEvery(DELETE_PROCEDURE, deleteProcedureEffect);
}

function* proceduresSaga() {
    yield all([
        fork(watchGetListProcedures),
        fork(watchGetAdminListProcedures),
        fork(watchGetSelectedProcedure),
        fork(watchCreateProcedure),
        fork(watchUpdateProcedure),
        fork(watchDeleteProcedure),
    ]);
}

export default proceduresSaga;
